import { render, staticRenderFns } from "./exExpertScoringIndex.vue?vue&type=template&id=70125d86"
import script from "./exExpertScoringIndex.vue?vue&type=script&lang=js"
export * from "./exExpertScoringIndex.vue?vue&type=script&lang=js"
import style0 from "./exExpertScoringIndex.vue?vue&type=style&index=0&id=70125d86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports